export const Logger = {
  error: (err: any, context?: any) => {},
  event(name: string, data: any) {},
};
